"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slicesToJsx = exports.nestSlices = exports.getSliceGroupsError = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var contentGroupRoleModifiersMap = {
  Columns: 'columns'
};
var sliceTypeGroupStart = 'content_group_start';
var sliceTypeGroupEnd = 'content_group_end';

var getSliceGroupsError = function getSliceGroupsError(slices) {
  var sliceCount = slices.length;
  var depth = 0;

  for (var i = 0; i < sliceCount; i++) {
    if (slices[i].slice_type === sliceTypeGroupStart) {
      depth += 1;
    } else if (slices[i].slice_type === sliceTypeGroupEnd) {
      depth -= 1;
    }

    if (depth < 0) {
      return 'Unexpected [Content Group End] slice: Review Prismic slices configuration to ensure pairing of Content Group Start and Content Group End instances';
    }
  }

  if (depth > 0) {
    return '[Content Group Start] and [Content Group End] mismatch: One or more Content Group End slices are missing. Review Prismic slices configuration';
  }

  return null;
};

exports.getSliceGroupsError = getSliceGroupsError;

var nestSlices = function nestSlices(slices) {
  var _sliceHandlers;

  var sliceHandlers = (_sliceHandlers = {
    "default": function _default(slice, depth) {
      depth.at(-1).children.push(slice);
    }
  }, _defineProperty(_sliceHandlers, sliceTypeGroupStart, function (slice, depth) {
    var child = {
      children: [],
      id: slice.id
    };

    if (slice.primary) {
      child.key = slice.primary.key;
      child.role = slice.primary.role;
    }

    depth.at(-1).children.push(child);
    depth.push(child);
  }), _defineProperty(_sliceHandlers, sliceTypeGroupEnd, function (_slice, depth) {
    var isRoot = depth.length === 1;

    if (!isRoot) {
      depth.pop();
    }
  }), _sliceHandlers);
  var rootGroup = [{
    children: []
  }];
  var nestedSlices = slices.reduce(function (depth, slice) {
    var sliceHandler = sliceHandlers[slice.slice_type] || sliceHandlers["default"];
    sliceHandler(slice, depth);
    return depth;
  }, rootGroup);
  return nestedSlices[0].children;
};

exports.nestSlices = nestSlices;

var generateSliceGroupClasses = function generateSliceGroupClasses(item) {
  var base = 'slice-group';
  var content = "".concat(base, "__content");
  var modifier = contentGroupRoleModifiersMap[item.role];
  var classNames = ['se-container', base];
  var classNamesContent = [content];

  if (modifier) {
    classNames.push("".concat(base, "--").concat(modifier));
    classNamesContent.push("".concat(content, "--").concat(modifier));
  }

  if (item.key) {
    classNames.push("".concat(base, "--").concat(item.key));
    classNamesContent.push("".concat(content, "--").concat(item.key));
  }

  return {
    className: classNames.join(' '),
    classNameContent: classNamesContent.join(' ')
  };
};

var slicesToJsx = function slicesToJsx(array, componentMap, props) {
  return array.reduce(function (result, item) {
    var isContentGroup = item.id && item.children;
    var Component = componentMap[item.slice_type];

    if (isContentGroup) {
      var _generateSliceGroupCl = generateSliceGroupClasses(item),
          className = _generateSliceGroupCl.className,
          classNameContent = _generateSliceGroupCl.classNameContent;

      result.push( /*#__PURE__*/_react["default"].createElement("div", {
        key: item.id,
        className: className
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classNameContent
      }, slicesToJsx(item.children, componentMap, props))));
    } else if (Component) {
      result.push( /*#__PURE__*/_react["default"].createElement(Component, _extends({
        sliceData: item,
        key: item.id
      }, props)));
    }

    return result;
  }, []);
};

exports.slicesToJsx = slicesToJsx;
var _default2 = {
  getSliceGroupsError: getSliceGroupsError,
  nestSlices: nestSlices,
  slicesToJsx: slicesToJsx
};
exports["default"] = _default2;